import { render } from "./GoldenLayoutComponent.vue?vue&type=template&id=3cac42a4&ts=true"
import script from "./GoldenLayoutComponent.vue?vue&type=script&lang=ts"
export * from "./GoldenLayoutComponent.vue?vue&type=script&lang=ts"

import "./GoldenLayoutComponent.vue?vue&type=style&index=0&id=3cac42a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__